import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/api/client';
import type { Paginated, PatientSummary } from '@/api/types';

/** Nombre de dossiers patients (affiché dans le menu, rafraîchi toutes les minutes). */
export function usePatientCount(enabled: boolean): number | undefined {
  const query = useQuery({
    queryKey: ['patients', 'count'],
    queryFn: () =>
      apiFetch<Paginated<PatientSummary>>('/patients', { query: { page_size: 1 } }).then(
        (p) => p.count,
      ),
    enabled,
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
  return query.data;
}

/** 1 234 → « 1 234 » ; au-delà de 99 999 → « 99k+ » pour tenir dans la pastille. */
export function formatCount(n: number): string {
  if (n > 99_999) return '99k+';
  return n.toLocaleString('fr-FR').replace(/\u202f|\u00a0/g, ' ');
}
